import React from 'react'
import styles from "../../styles/GamesBuiltonBuildbox.module.scss"
const GamesBuiltonBuildbox = () => {


  const DownloadApps = (appleUrl: string, googleUrl: string) => {
    return ( 
      <div className={styles.buttonContainerAppDownload}>
        <div className={styles.buttonDownloadApp}>
          <a
            href={appleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.leftButton}
          >
            <img
              className={styles.gameAppBtns}
              src={"https://frontend-assets.buildbox.com/AppStoreButton.png"}
              alt="Buildbox World App Store Button"
            />
          </a>
        </div>
        <div className={styles.buttonDownloadApp}>
          <a
            href={googleUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.rightButton}
          >
            <img
              className={styles.gameAppBtns}
              src={"https://frontend-assets.buildbox.com/GooglePlay.webp"}
              alt="Buildbox World Google Play Button"
            />
          </a>
        </div>
      </div>
    )
    
  }

  return (
    <div className={styles.container}>
      {/* <div className={styles.titleContent}>
        <h1>Games Built on Buildbox</h1>
      </div>
      <div className={styles.buildOnBuildbox}>
        <ul>
          <li>
            <p>Over a billion people have played games built on Buildbox</p>
          </li>
          <li>
            <p>Over 40,000 new games are created every month</p>
          </li>
          <li>
            <p>Apple and Google love featuring Buildbox games</p>
          </li>
        </ul>
      </div> */}

      {/* <div className={styles.titleContent}>
        <h1>Apple regularly features Buildbox Games</h1>
      </div> */}
      <div className={styles.gameOfTheDay}>

        <div className={styles.games}>
          <img src="https://frontend-assets.buildbox.com/BB4_GOTD_Images_LastPocket.webp" loading="lazy" alt="Game of the Day" />
          <h1 className={styles.gameTitle}>Last Pocket</h1>
          {DownloadApps ("https://apps.apple.com/us/app/last-pocket/id6445848461", "https://play.google.com/store/apps/details?id=com.vikaspawar.oddeightball" )
          }
        </div>

        <div className={styles.games}> 
          <img src="https://frontend-assets.buildbox.com/BB4_GOTD_Images_MultiImpact.webp" loading="lazy" alt="Game of the Day" />
          <h1 className={styles.gameTitle}>Multi Impact Smash</h1>
          { DownloadApps("https://apps.apple.com/us/app/multi-impact-smash/id6447011302", "https://play.google.com/store/apps/details?id=top.maverick.multiimpactand")}
        </div>

        <div className={styles.games}>
          <img src="https://frontend-assets.buildbox.com/BB4_GOTD_Images_PizzaHero.webp" loading="lazy" alt="Game of the Day" />
          <h1 className={styles.gameTitle} > Pizza Hero</h1>
         {
          DownloadApps("https://apps.apple.com/us/app/pizza-hero/id1663899823", "https://play.google.com/store/apps/details?id=com.astrohound.hero")
         }
        </div>
      </div>
    </div>
  )
}

export default GamesBuiltonBuildbox